import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={128}
      height={128}
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.662 34.925H39.687v11.113c0 .876-.71 1.587-1.587 1.587h-6.35c-.877 0-1.587-.71-1.587-1.587V34.925H10.556c-.57 0-1.032.462-1.032 1.032v74.136c0 .57.462 1.032 1.032 1.032h101.124c.57 0 1.032-.462 1.032-1.032V35.957c0-.57-.462-1.032-1.032-1.032h-8.493v11.113c0 .876-.711 1.587-1.588 1.587h-6.35c-.877 0-1.588-.71-1.588-1.587V34.925z"
        fill="#329C7F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.662 38.1H39.687v6.35c0 .877-.71 1.587-1.587 1.587h-6.35c-.877 0-1.587-.71-1.587-1.587V38.1H15.319c-.57 0-1.032.462-1.032 1.032v74.136c0 .57.462 1.032 1.032 1.032h101.124c.57 0 1.032-.462 1.032-1.032V39.132c0-.57-.462-1.032-1.032-1.032h-13.255v6.35c0 .877-.711 1.587-1.588 1.587h-6.35c-.877 0-1.588-.71-1.588-1.587V38.1z"
        fill="#4A4A48"
      />
      <rect
        x={38.1}
        y={25.4}
        width={19.05}
        height={6.35}
        rx={1.032}
        transform="rotate(90 38.1 25.4)"
        fill="#329C7F"
      />
      <rect
        x={101.6}
        y={25.4}
        width={19.05}
        height={6.35}
        rx={1.032}
        transform="rotate(90 101.6 25.4)"
        fill="#329C7F"
      />
      <path
        d="M59.081 73.723c.762 2.286 2.591 3.62 5.41 3.62 2.858 0 4.687-1.296 5.449-3.582.229-.723.343-1.676.343-5.029 0-3.886-.114-4.724-.381-5.562-.648-2.02-2.058-3.048-4.42-3.048-1.18 0-2.21.457-2.781 1.066h-.038v-6.324c0-.152.076-.229.229-.229h7.01c.228 0 .38-.152.38-.38v-2.782c0-.229-.151-.381-.38-.381H59.539c-.229 0-.381.152-.381.381v13.335c0 .229.152.381.38.381h2.592c.304 0 .457-.076.571-.343.267-.686.8-1.143 1.753-1.143.914 0 1.524.381 1.79 1.22.115.342.153.761.153 3.81 0 3.047-.038 3.504-.153 3.847-.266.8-.838 1.22-1.79 1.22-.953 0-1.486-.458-1.753-1.258-.114-.38-.152-.724-.152-1.79 0-.305-.19-.42-.458-.381l-2.971.304c-.229.038-.343.19-.343.458 0 .99.076 1.867.304 2.59zM45.905 98c.133 0 .222-.089.222-.222v-5.979l2.89-8.69c.044-.133 0-.222-.178-.222h-1.912c-.155 0-.222.067-.266.222l-1.645 5.845h-.067L43.26 83.11c-.044-.155-.11-.222-.267-.222h-1.955c-.178 0-.223.089-.178.222l2.89 8.69v5.979c0 .133.088.222.221.222h1.934zm5.15-.222c0 .133.09.222.223.222h6.2c.134 0 .223-.089.223-.222v-1.712c0-.133-.09-.222-.223-.222h-3.911c-.089 0-.133-.044-.133-.133v-4.134c0-.089.044-.133.133-.133h3.378c.133 0 .222-.09.222-.223V89.51c0-.133-.089-.222-.222-.222h-3.378c-.089 0-.133-.045-.133-.134v-3.978c0-.089.044-.133.133-.133h3.911c.134 0 .223-.09.223-.222v-1.712c0-.133-.09-.222-.223-.222h-6.2c-.134 0-.223.089-.223.222v14.669zm8.22 0c-.022.133.045.222.178.222h1.89c.155 0 .222-.089.244-.222l.6-3.045h3l.6 3.045c.023.133.09.222.245.222h1.89c.132 0 .2-.089.177-.222l-3.2-14.669c-.023-.133-.112-.222-.245-.222h-1.867c-.133 0-.2.089-.244.222l-3.267 14.669zm3.29-5.045l1.111-5.623h.067l1.067 5.623h-2.245zM78.009 98c.111 0 .156-.111.111-.222l-2.133-6.534c1.133-.645 1.8-1.89 1.8-3.868 0-3.311-1.623-4.489-4.312-4.489H70.43c-.133 0-.222.089-.222.222v14.669c0 .133.089.222.222.222h1.934c.133 0 .222-.089.222-.222v-5.823c0-.09.044-.134.133-.134h1.134l1.845 6.023c.044.112.11.156.244.156h2.067zm-4.512-8.29h-.778c-.088 0-.133-.044-.133-.133v-4.4c0-.09.044-.134.133-.134h.778c1.334 0 1.912.555 1.912 2.333 0 1.8-.578 2.334-1.912 2.334zm14.214 3.956c0-2.578-.778-3.645-2.756-4.423l-.91-.355c-1.201-.467-1.468-.89-1.468-2.29 0-1.244.445-1.822 1.378-1.822.978 0 1.378.69 1.423 1.934 0 .133.11.2.244.178l1.778-.267c.133-.045.2-.111.2-.245-.133-2.356-1.222-3.689-3.712-3.689-2.489 0-3.667 1.422-3.667 4.023 0 2.356.623 3.445 2.712 4.267l.911.355c1.178.467 1.49 1 1.49 2.623 0 1.645-.468 2.156-1.423 2.156-1.023 0-1.49-.622-1.556-2.223 0-.133-.089-.222-.245-.2L80.245 94c-.134.023-.178.112-.178.245.066 2.645 1.333 3.956 3.778 3.956 2.867 0 3.867-1.556 3.867-4.534z"
        fill="#F3AD3D"
      />
    </Svg>
  )
}

const SvgCalendar3 = styled(BaseComponent)`
  outline: none;
`
export default SvgCalendar3
